<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div>
      <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
        You have only view permission.
      </div>
      <div class="noData" v-show="ifTeamleaderPermission">
        <span class="text">Click on ‘Add New’ to add new Band in the following list</span>
        <button class="addnewbtn" v-if="bandsList.length>3" @click="CreateForm()">
          <img src="@/assets/group-5.svg" />
          <b>Add New</b>
        </button>
      </div>
      <div v-if="bandsList.length" :disabled="!(ifTeamleaderPermission)">
        <data-table
          v-if="bandsList[0] && bandsList[0].criteria.type=='Salary Range'"
          :columns="tableColumns"
          :tableData="bandsList"
          :checkbox="false"
          :withForm="false"
          :showhistory="false"
          @editStart="initEditStart"
          @delete="deleteItem"
          :search="search"
        >
          <template v-slot:rowcontent="slotprops">
            <p
              v-if="slotprops.value.column.key!='increment' && slotprops.value.column.key!='criteria'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <div v-if="slotprops.value.column.key=='criteria'">
              <span>{{slotprops.value.record.criteria.from}} - {{slotprops.value.record.criteria.to}}</span>
            </div>
            <div
              v-if="slotprops.value.column.key=='increment' && slotprops.value.record.salaryIncrementType == 'fixed'"
            >Rs. {{slotprops.value.record.incrementValue}}</div>
            <div
              v-if="slotprops.value.column.key=='increment' && slotprops.value.record.salaryIncrementType == 'Percentage'"
            >{{slotprops.value.record.incrementValue}} %</div>
          </template>
        </data-table>
        <data-table
          v-else
          :columns="tableColumns"
          :tableData="bandsList"
          :checkbox="false"
          :withForm="false"
          :showhistory="false"
          @editStart="initEditStart"
          @delete="deleteItem"
          :search="search"
        >
          <template v-slot:rowcontent="slotprops">
            <p
              v-if="slotprops.value.column.key!='range' && slotprops.value.column.key!='increment' && slotprops.value.column.key!='criteria'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</p>
            <p
              v-if="slotprops.value.column.key!='range' && slotprops.value.column.key!='increment' && slotprops.value.column.key=='criteria' && (bandsList[0] && bandsList[0].criteria.type !='Employee Category & Sub Category')"
            >{{getNames(slotprops.value.record.criteria.value)}}</p>
            <div
              v-if="slotprops.value.column.key!='range' && slotprops.value.column.key!='increment' && slotprops.value.column.key=='criteria' && (bandsList[0] && bandsList[0].criteria.type =='Employee Category & Sub Category')"
            >
              <p
                v-for="(item, i) of slotprops.value.record.criteria.value"
                :key="i"
              >{{item.category}}{{item.subCategory ? ' : '+(i < slotprops.value.record.criteria.value.length-1 ? item.subCategory+',': item.subCategory): ((i < slotprops.value.record.criteria.value.length-1) ? ',' :'')}}</p>
            </div>
            <div v-if="slotprops.value.column.key=='range'">
              <div
                class="margin-t-xs"
                v-for="(slab,index) of slotprops.value.record[slotprops.value.column.key]"
                :key="index"
              >
                <span>{{slab}}</span>
              </div>
            </div>
            <div
              v-if="slotprops.value.column.key=='increment' && slotprops.value.record.slabs.length"
            >
              <div
                class="margin-t-xs"
                v-for="(slab,index) of slotprops.value.record.slabs"
                :key="index"
              >
                <div v-if="slab.salaryIncrementType=='Percentage'">
                  <span>{{slab.incrementValue}} %</span>
                </div>

                <div v-if="slab.salaryIncrementType=='fixed'">
                  <span>Rs {{slab.incrementValue}}</span>
                </div>
              </div>
            </div>
            <div
              v-if="slotprops.value.column.key=='increment' && !slotprops.value.record.slabs.length"
            >
              <div v-if="slotprops.value.record.salaryIncrementType=='Percentage'">
                <span>{{slotprops.value.record.incrementValue}} %</span>
              </div>

              <div v-if="slotprops.value.record.salaryIncrementType=='fixed'">
                <span>Rs {{slotprops.value.record.incrementValue}}</span>
              </div>
            </div>
          </template>
        </data-table>
      </div>
    </div>

    <pop-up-message
      v-if="showPopup"
      :message="popupMessage"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Delete'"
    >
      <!-- Author: Vaishnavi
      Date: 10/12/2019
      Issue Description: Consistent buttons across application-->
      <template v-slot:bottomContent>
        <btn-grp>
          <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
          <popup-btn text="Delete" type="primary" @click="deleteEvent" />
        </btn-grp>
      </template>
    </pop-up-message>

    <form-add-button
      v-show="showAddBtn && bandsList.length<=3"
      main_text="+ Add New"
      sub_text="Band"
      @click="CreateForm()"
      v-if="ifTeamleaderPermission"
    ></form-add-button>
    <bottom-action-container>
      <btn-skip @navClicked="continuee"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previous" />
          <btn text="Next" type="primary" @click="continuee" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
// import CrudDesignations from './crud_designations.vue';
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "Bands",
  props: {
    showUpdated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("onboard/salary_bands", {
      bandsDataAll: state => state.data
      // isFetching: state => state.isFetching,
      // isSaving: state => state.isSaving,
      // isDeleting: state => state.isDeleting
    }),
    ...mapState({
      orgId: state => state.onboard.organization.id
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    // bandsData() {
    //   return this.bandData;
    // }
    showAddBtn() {
      return !this.isFormActive;
    },
    isLoading() {
      return this.isFetching;
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.salaryBandsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.salaryBandsValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  data() {
    return {
      showBands: false,
      mode: "add",
      showEnable: false,
      isFormActive: false,
      blankInstance: {
        key: "",
        description: ""
      },
      instance: null,
      tableColumns: [],
      popupType: "Success",
      popupMessage: "",
      showPopup: false,
      currentRecord: {},
      toast: false,
      message: "",
      components: [
        { name: "Basic", value: "BASIC" },
        { name: "Gross", value: "GROSS" },
        { name: "CTC", value: "CTC" }
      ],
      bandsColumnNamesOthers: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "",
          key: "criteria"
        }
        // {
        //   label: "Slab",
        //   key: "range"
        // },
        // {
        //   label: "Increment",
        //   key: "increment"
        // }
      ],
      bandsColumnNamesRange: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "",
          key: "criteria"
        },
        {
          label: "",
          key: "increment"
        }
      ],
      updatedList: [],
      search: "",
      errmsg: "",
      bandsList: [],
      subCriteriaList: [],
      // addBands: false
      salaryBandsValue: false,
      role: ""
    };
  },
  mounted() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  activated() {
    this.fetchAll();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/salary_bands/fetchAll",
      act_delete: "onboard/salary_bands/delete",
      act_create: "onboard/salary_bands/create",
      act_update: "onboard/salary_bands/update",
      act_changeEditMode: "onboard/salary_bands/changeEditMode",
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetch_empCategories: "onboard/empCategory/fetchAll",
      act_fetch_stepper_status: "onboard/legal_entities/fetchStepperStatus"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /* server call to get salary bands for current LE */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        if (res.data.status) {
          this.bandsList = res.data.payload.data;
          if (this.bandsList.length) {
            this.getSubCriteria(this.bandsList[0].criteria.type);
            // if (this.bandsList[0].criteria.type == "Salary Range") {
            //   this.bandsColumnNamesRange.forEach(element => {
            //     if (element.key == "criteria") {
            //       element.label = `Criteria (${this.bandsList[0].criteria.type})`;
            //     }
            //     if (element.key == "increment") {
            //       element.label = `Increment on ${
            //         this.components.find(
            //           item => item.value == this.bandsList[0].salary_type
            //         ).name
            //       }`;
            //     }
            //   });
            //   this.tableColumns = this.bandsColumnNamesRange;
            // } else {
              this.bandsColumnNamesOthers.forEach(element => {
                if (element.key == "criteria") {
                  element.label = `Criteria (${this.bandsList[0].criteria.type})`;
                }
                if (element.key == "increment") {
                  element.label = `Increment on ${
                    this.components.find(
                      item => item.value == this.bandsList[0].salary_type
                    ).name
                  }`;
                }
              });
              this.tableColumns = this.bandsColumnNamesOthers;

              this.bandsList.forEach(element => {
                element["range"] = [];
                element["increment"] = [];
                element["subcriteria"] = "";
                for (var i = 0; i < element.slabs.length; i++) {
                  element["range"].push(
                    "slab" +
                      (i + 1) +
                      "(" +
                      element.slabs[i].from +
                      " - " +
                      element.slabs[i].to +
                      ")"
                  );
                  element["increment"].push(element.slabs[i].incrementValue);
                }
              });
            // }
          }
          this.getStepperStatus();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async getStepperStatus() {
      try {
        let res = await this.act_fetch_stepper_status({le_id: this.le_id, index: this.$route.params.entity_index});
        if (res.data.status) {
          //console.log(res.data.payload.data);
        }
        //console.log({res});
      } catch (err) {
        this.errmsg = err;
        this.toast = true;
      }
    },

    /* function to get name of criteria based on id */
    getNames(value) {
      let tempArray = [];
      if (this.subCriteriaList.length) {
        value.forEach(element => {
          tempArray.push(
            this.subCriteriaList.find(item => item.id == element).name
          );
        });
        return tempArray.join();
      }
    },


    /* function to get the subcriterias */
    getSubCriteria(value) {
      if (value == "Salary Grade") {
        this.getGrades();
      } else if (value == "Designation") {
        this.getDesignations();
      } else if (value == "Employee Category & Sub Category") {
        this.getEmpCategoryList();
      } else if (value == "Business Units") {
        this.getDepartment();
      }
    },


    /* function to go to create salary bands page */
    async CreateForm() {
      try {
        await this.act_changeEditMode({ editMode: false, record: {} });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/addBands`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go to edit salary bands page(create salary bands page) */
    async initEditStart(record) {
      try {
        await this.act_changeEditMode({ editMode: true, record: record });
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/${this.$route.params.step_name}/modifybands`
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to hide and cancel the deletion of band */
    cancelEvent() {
      this.showPopup = false;
    },

    /* function to open confirmation pop-up to delete a pay group */
    deleteItem(record) {
      this.showPopup = true;
      this.popupType = "ConfirmDelete";
      this.popupMessage = "Are you sure you want to delete ?";
      this.currentRecord = record;
      // this.deleteEvent(record);
    },

    /* server call to delete a salary band */
    async deleteEvent() {
      try {
        let res = await this.act_delete([this.currentRecord, this.le_id]);
        if (res.data.status) {
          let index = this.bandsList.findIndex(
            item => item.id == this.currentRecord.id
          );
          this.bandsList.splice(index, 1);
          if (!this.bandsList.length) {
            this.tableColumns = [];
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
      this.showPopup = false;
    },

    /* function to go to employee categories page */
    previous() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/empCategories`
      );
    },

    /* function to go to next step */
    continuee() {
      // this.$emit("stepNum", 1);
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/misc`
      });
    },

    /* server call to get grades */
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get designations */
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get Employee categories */
    async getEmpCategoryList() {
      try {
        let res = await this.fetch_empCategories(this.le_id);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to get BUs */
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgId);
        if (res.data.status) {
          this.subCriteriaList = res.data.payload.data;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.salaryBandsValue = data.data.user.permissions.salary_bands ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/form.scss";
.mr-bt-17 {
  margin: 17px 0px;
}
.download-btn {
  margin: 10px 0px;
}
.noData {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}
.export-button {
  width: 70px;
  height: 25px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
}
.addnewbtn {
  float: right;
  b {
    margin-left: 8px;
    color: #34c0be;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
